module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="m-modal modal-dialog">\n    <div class="m-modal-content modal-content">\n\n        <div class="m-modal-header dialog-header-region">\n            <div class="m-modal-header__title">'+
((__t=( obj.getTitle() ))==null?'':__t)+
'</div>\n            <div class="m-modal__close close"></div>\n\n            <div class="dialog-tabs-region js-tabs"></div>\n        </div>\n\n        <div class="m-modal-body dialog-body-region">\n        </div>\n\n        <div class="m-modal-footer dialog-footer-region">\n\n            <div class="m-modal-footer__left">\n                ';
 _.forEach(_.get(getDialogModel(), 'buttons.left'), function(button) { 
__p+='\n                    <a class="'+
((__t=( getConditionalStr(button.icon, 'm-btn-icon', 'm-btn') ))==null?'':__t)+
' '+
((__t=( getConditionalStr(button.primary, 'm-btn--primary','') ))==null?'':__t)+
' m-btn--'+
((__t=( button.slug ))==null?'':__t)+
' js-dialog-button" role="button" data-action="'+
((__t=( button.action ))==null?'':__t)+
'">'+
((__t=( button.label ))==null?'':__t)+
'</a>\n                ';
 }) 
__p+='\n            </div>\n            <div class="m-modal-footer__right">\n                ';
 _.forEach(_.get(getDialogModel(), 'buttons.right'), function(button) { 
__p+='\n                    <a class="'+
((__t=( getConditionalStr(button.icon, 'm-btn-icon', 'm-btn') ))==null?'':__t)+
' '+
((__t=( getConditionalStr(button.primary, 'm-btn--primary','') ))==null?'':__t)+
' m-btn--'+
((__t=( button.slug ))==null?'':__t)+
' js-dialog-button" role="button" data-action="'+
((__t=( button.action ))==null?'':__t)+
'">'+
((__t=( button.label ))==null?'':__t)+
'</a>\n                ';
 }) 
__p+='\n            </div>\n\n\n        </div>\n\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/dialog-view/templates/layout.html
// module id = 407
// module chunks = 0